import React, { useState, useContext } from "react";
import styled from "styled-components";

import { UIStateContext } from "../../provider";
import { ConfirmModal } from "../../modals";
import UIManager from "../../service/ui-manager";
import { ModalService, ModalTypes } from "../../service/modal-service";
import MaterialIconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Row, Col, Text } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import {
  faTimes,
  faPaintBrush,
  faArrowCircleDown,
} from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Row)`
  width: 98%;
  height: 100%;
  margin-left: 1%;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.BLACK_0};
  &:hover {
    cursor: pointer;
  }
`;

export default () => {
  const [UIState, setUIState] = useContext(UIStateContext);
  const [hover, setHover] = useState(false);
  const overlayColor = Theme.color.GRAY_0;

  const isDark = UIState.playerTheme === "dark";

  const changeTheme = (event) => {
    event.stopPropagation();
    event.cancelBubble = true;
    const change = () => {
      setUIState({ ...UIState, playerTheme: isDark ? "dynamic" : "dark" });
    };
    ModalService.showModal(ModalTypes.CUSTOM, {
      width: "30%",
      height: "140px",
      content: (
        <ConfirmModal
          title={`Switch to  ${isDark ? "dynamic" : "dark"} theme ?`}
          handleSubmit={change}
        />
      ),
    });
  };

  const handleClose = () => {
    UIManager.collapsePlayer();
  };

  return (
    <Wrapper
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      onClick={handleClose}
    >
      <Text
        marginLeft="10px"
        fontSize="30px"
        fontWeight={600}
        color={overlayColor}
      >{`PLAYER`}</Text>
      {hover && (
        <MaterialIconButton
          style={{ marginLeft: "10px" }}
          size="large"
          onClick={handleClose}
        >
          <FontAwesomeIcon
            style={{ fontSize: "24px", color: overlayColor }}
            icon={faArrowCircleDown}
          />
        </MaterialIconButton>
      )}
      <MaterialIconButton
        style={{ marginLeft: "auto" }}
        size="large"
        onClick={changeTheme}
      >
        <FontAwesomeIcon
          style={{ fontSize: "26px", color: overlayColor }}
          icon={faPaintBrush}
        />
      </MaterialIconButton>
      <MaterialIconButton
        style={{ marginLeft: "2%", marginRight: "2%" }}
        size="large"
        onClick={handleClose}
      >
        <FontAwesomeIcon
          style={{ fontSize: "32px", color: overlayColor }}
          icon={faTimes}
        />
      </MaterialIconButton>
    </Wrapper>
  );
};
